/*
 * @Author: Czy
 * @Date: 2021-11-17 16:14:33
 * @LastEditTime: 2022-03-24 14:55:14
 * @FilePath: /plant-protection-association/src/api/index.js
 *  
 */
import axios from 'axios'


// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: 'http://192.168.1.94:7001/exhibition/api',
    baseURL: 'http://81.68.224.88:7001/exhibition/api', 
    // 超时
    timeout: 10000
   
  })

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    console.log('123123',res.data.msg);
    const msg =  res.data.msg || errorCode['default'] ||errorCode[code] 
  
    if (code == 500) {
    console.error(msg)
      return Promise.reject(new Error(msg))
    } else if (code != 200) {
        console.error(msg)
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/api/index.js